import React from 'react';
import styled from '@emotion/styled';

const Title = styled.h1({
    minHeight: '45px',
    fontSize: '40px',
    fontFamily: '\'Cabin Sketch\', arial, serif',
    fontWeight: 'normal',
    color: '#193340',
    textShadow: '3px 3px 0 #ddd',
    padding: '5px',
    margin: 0,
    backgroundColor: '#fff',
    borderBottom: '1px solid #ccc',
});

export type TitlePaneProps = {
    title: string;
}

export const TitlePane = (props: TitlePaneProps) => {
    return (
        <Title>{props.title}</Title>
    );
};
